import React from 'react'
import CustomButton from '../customButton/ui/main/CustomButton'
import Icon from '../../baseComponents/gui/icon/Icon'
import { safeHTML } from '../../../utils/safeHTML'
import classNames from 'classnames'
import { useModal } from '../../../hooks/useModal'
import { useTranslation } from '../../../translations'
import { useUser } from '../../../redux/reducer/user'
import { getCountryNames, getSelectCountryModalProps } from '../../../constants/country'
import { useLanguageControls } from '../../../hooks/useLanguageControls'

const SelectCountryButton = React.forwardRef(function SelectCountryButton(
  { text, className, callbacks, isIcon, isBg, isGameStopped },
  _ref,
) {
  const { addModal } = useModal()
  const { t } = useTranslation()
  const { language } = useLanguageControls()
  const { profile } = useUser()
  const countryNames = getCountryNames(t)
  const selectedCountry = profile?.userCountry

  const openCountryModal = () => {
    addModal({
      type: 'selectCountryModal',
      props: {
        ...getSelectCountryModalProps({
          t,
          profile,
          language,
        }),
        isGameStopped: isGameStopped,
      },
    })
  }

  const handleClick = (event) => {
    event.stopPropagation()
    openCountryModal()
  }

  const buttontText = text ? `${text}:&nbsp;` : null

  return (
    <CustomButton
      callbacks={callbacks}
      className={classNames(
        'select-country-button',
        'button_select-country-button',
        {
          'select-country-button_bg_active': isBg,
        },
        className,
      )}
      onClick={handleClick}
      icon={isIcon ? 'buttons/select-country-icon' : null}
    >
      {safeHTML(buttontText)}
      <span className={`select-country-button__span button__text custom-button__text`}>
        {selectedCountry
          ? countryNames[selectedCountry] || selectedCountry
          : t('selectModalCountry.countries.empty')}
        <Icon
          name='buttons/chevron-right'
          className='select-country-button__icon_chevron custom-button__icon'
        />
      </span>
    </CustomButton>
  )
})

export default SelectCountryButton
SelectCountryButton.propTypes = {}
